import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { invoiceNoteDelete } from '../../lib/redux/actions/invoiceNote';
import { connect } from 'react-redux';
import InvoiceNote from './InvoiceNote';
import { invoiceSingleFetch } from '../../lib/redux/actions/invoices';
import * as PropTypes from 'prop-types';

const mapStateToProps = (state) => ({
  ...state.invoices,
});

const mapDispatchToProps = {
  invoiceNoteDelete,
  invoiceSingleFetch,
};

class InvoiceNotes extends React.Component {
  render() {
    const { invoiceNotes, invoiceNoteDelete, invoiceSingleFetch, invoice } = this.props;
    const deleteNote = (noteId) => {
      invoiceNoteDelete(noteId).then(() => {
        invoiceSingleFetch(invoice.id);
      });
    };

    return (
      <Row>
        <Col>
          <div className="invoice-batch-single__section mb-3">
            <div className="invoice-batch-single__section-icon">
              <i className="fas fa-envelope" />
            </div>
            <h2 className="invoice-batch-single__section-header">Notes</h2>
            <div className="invoice-batch-single__notes-wrapper">
              {(!invoiceNotes || invoiceNotes.length === 0) && <p>No notes have been added to this Invoice</p>}
              <TransitionGroup>
                {invoiceNotes &&
                  invoiceNotes.length > 0 &&
                  invoiceNotes.map((note) => (
                    <CSSTransition key={note.id} timeout={500} classNames="fade">
                      <InvoiceNote note={note} deleteNote={deleteNote} />
                    </CSSTransition>
                  ))}
              </TransitionGroup>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

InvoiceNotes.propTypes = {
  invoice: PropTypes.object.isRequired,
  invoiceNoteDelete: PropTypes.func.isRequired,
  invoiceSingleFetch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceNotes);
